import { gql } from '@apollo/client';
/**
 * @const DeleteMediaMutation
 * @since 1.0.0
 */
export const DeleteMediaMutation = gql `
  mutation DeleteMediaMutation($input: DeleteMediaInput!) {
    deleteMedia(input: $input)
  }
`;
